import { useState } from 'react';

export const useLOVForm = () => {
  const [openBackgroundDrawer, setOpenBackgroundDrawer] = useState(false);
  const [openTitleDrawer, setOpenTitleDrawer] = useState(false);
  const [openSettingsDrawer, setOpenSettingsDrawer] = useState(false);
  const [openImageSelectionDrawer, setOpenImageSelectionDrawer] =
    useState(false);
  const [openProductsDrawer, setOpenProductsDrawer] = useState(false);
  const [isDefaultImageSourceUpdated, setIsDefaultImageSourceUpdated] =
    useState<boolean | undefined>();

  const onToggleBackgroundDrawer = () =>
    setOpenBackgroundDrawer(!openBackgroundDrawer);

  const onToggleTitleDrawer = () => setOpenTitleDrawer(!openTitleDrawer);

  const onToggleSettingsDrawer = () =>
    setOpenSettingsDrawer(!openSettingsDrawer);

  const onToggleImageSelectionDrawer = () => {
    setIsDefaultImageSourceUpdated(false);
    setOpenImageSelectionDrawer(!openImageSelectionDrawer);
  };

  const onToggleProductsDrawer = () =>
    setOpenProductsDrawer(!openProductsDrawer);

  const onToggleDefaultImageUpdated = (val: boolean | undefined) =>
    setIsDefaultImageSourceUpdated(val);

  return {
    openBackgroundDrawer,
    openTitleDrawer,
    openSettingsDrawer,
    openImageSelectionDrawer,
    openProductsDrawer,
    isDefaultImageSourceUpdated,
    onToggleBackgroundDrawer,
    onToggleTitleDrawer,
    onToggleImageSelectionDrawer,
    onToggleSettingsDrawer,
    onToggleProductsDrawer,
    onToggleDefaultImageUpdated,
  };
};
